export default {
	admins: 'Administratorzy',
	description: 'Opis grupy',
	changePicture: 'Zmień zdjęcie w tle',
	options: {
		invite: 'Zaproś osoby',
		members: 'Członkowie',
		settings: 'Ustawienia grupy',
		leave: 'Opuść grupę'
	},
	dialogs: {
		inviteMembers: {
			header: 'Zaproś użytkowników do grupy',
			invite: 'Zaproś wybranych'
		}
	},
	settings: {
		header: 'Ustawienia grupy',
		removeFromGroup: 'Usuń z grupy',
		tabs: {
			one: {
				title: 'Ogólne'
			},
			two: {
				title: 'Zarządzanie członkami'
			}
		}
	}
}
